{
  function unmanageMyTimeLink(link) {
    link.setAttribute('ada-link-managed', '0');
    link.querySelectorAll('span.sr-only').forEach(span => {
      if (span.textContent.trim() === '(goes to new website)') {
        span.remove();
      }
    });
  }

  function unmanageMyTimeLinks(root = document) {
    root.querySelectorAll('a.mytime-widget-default-button-v2').forEach(unmanageMyTimeLink);
  }

  unmanageMyTimeLinks();

  // the mytime widget script injects/replaces this link after page load, so keep watching for it
  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('a.mytime-widget-default-button-v2')) {
          unmanageMyTimeLink(node);
        }
        unmanageMyTimeLinks(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}